
export default function Navigation() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm shadow-sm z-50">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-purple-600 rounded-lg flex items-center justify-center">
              <i className="ri-shield-keyhole-line text-white text-xl"></i>
            </div>
            <span className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent" style={{ fontFamily: '"Pacifico", serif' }}>SERVI-SUP</span>
          </div>
          
          <div className="hidden md:flex items-center gap-8">
            <button onClick={() => scrollToSection('home')} className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer whitespace-nowrap">Home</button>
            <button onClick={() => scrollToSection('features')} className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer whitespace-nowrap">Features</button>
            <button onClick={() => scrollToSection('about')} className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer whitespace-nowrap">About</button>
            <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer whitespace-nowrap">Contact</button>
          </div>

          <button className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer">
            <i className="ri-menu-line text-2xl text-gray-700"></i>
          </button>
        </div>
      </div>
    </nav>
  );
}
